// node_modules
import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
// Style
import styles from "./synonymsButton.module.scss";

type TSynonymsButtonProps = {
    isSynonymsSectionShown: boolean,
    synonymsCount: number,
    handleOpenSynonymsSection: (event: React.MouseEvent) => void,
    handleCloseSynonymsSection: () => void,
}

export const SynonymsButton: FC<TSynonymsButtonProps> = ({isSynonymsSectionShown, synonymsCount, handleOpenSynonymsSection, handleCloseSynonymsSection}: TSynonymsButtonProps) => {
    const getFindestSynonymsButton = (): JSX.Element | null => {
        // if synonyms section hidden & no synonyms
        if (!isSynonymsSectionShown && synonymsCount === 0) {
            return (
                <div title="Add synonyms" className={styles.addSynonymContainer} onClick={handleOpenSynonymsSection}>
                    <FontAwesomeIcon className={styles.addSynonymIcon} icon={faPlus} />
                </div>
            );
        }
        // if synonyms section is hidden & at least one synonym
        if (!isSynonymsSectionShown && synonymsCount >= 1) {
            return (
                <div title="Manage synonyms" className={styles.addSynonymContainer} onClick={handleOpenSynonymsSection}>
                    <span>{synonymsCount}</span>
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>
            );
        }
        // if synonyms section is shown & no synonyms
        if (isSynonymsSectionShown && synonymsCount === 0) {
            return (
                <div title="Close synonyms" className={styles.addSynonymContainer} onClick={handleCloseSynonymsSection}>
                    <span>{synonymsCount}</span>
                    <FontAwesomeIcon icon={faChevronUp} />
                </div>
            );
        }
        // if synonyms section is shown & at least one synonym
        if (isSynonymsSectionShown && synonymsCount >= 1) {
            return (
                <div title="Close synonyms" className={styles.addSynonymContainer} onClick={handleCloseSynonymsSection}>
                    <span>{synonymsCount}</span>
                    <FontAwesomeIcon icon={faChevronUp} />
                </div>
            );
        }
        // otherwise return null
        return null;
    };

    return getFindestSynonymsButton();
};